export default __webpack_public_path__ + "static/media/email-list-cancel.f20f4123.svg";